import { Box, Flex } from "@chakra-ui/react";
import Navbar from "../navbar";
import { useState } from "react";

const LayoutView = ({ children, noPadding, activePage, ...rest }) => {
  const [sideComp, setSideComp] = useState("");

  return (
    <Box
      maxW="100vw"
      overflowX={"hidden"}
      h={"100%"}
      minH="100vh"
      position={"relative"}
      {...rest}
    >
      <Navbar
        setSideComp={setSideComp}
        sideComp={sideComp}
        activePage={activePage}
      />
      <Flex
        justify={"center"}
        direction={"row"}
        align={"flex-start"}
        h="full"
        px={noPadding ? 0 : { base: "16px", md: "28px", xl: "48px" }}
        py={noPadding ? 0 : { base: "24px", md: "32px", xl: "40px" }}
        w={"100%"}
        maxW="1440px"
        mx="auto"
      >
        <Box w="full">{children}</Box>
      </Flex>
    </Box>
  );
};

export default LayoutView;
